// extracted by mini-css-extract-plugin
export default {"imageStyle":"styles_imageStyle__DkbE+","imageWrapperStyle":"styles_imageWrapperStyle__eixri","footerContainerStyles":"styles_footerContainerStyles__whhaw"};